import { pluralize } from '@fourthwall/utils/dist/string';
import React from 'react';
import * as S from './styled';
export const BadgeTableCell = ({ rules, children, hiddenBadgesCount }) => (React.createElement(S.Container, null,
    children,
    rules && (React.createElement(S.Rules, null,
        hiddenBadgesCount && hiddenBadgesCount > 0
            ? `+ ${hiddenBadgesCount} ${pluralize(hiddenBadgesCount, 'badge')}`
            : null,
        rules.map((rule, index) => (React.createElement("p", { key: index }, rule)))))));
